import { Daction, divStyle, styles } from '@/common';
import { validateEmail } from '@/functions';
import React, { useState } from 'react';
import { Drawer, Radio, RadioGroup, Input, InputGroup, useToaster, Message } from 'rsuite';

export default function GenerateAccess({ open, close, typeCode, setEmailList, emailList }) {
  const [value, setValue] = React.useState('Allow');
  const [newEmail, setNewEmail] = useState('');
  const toaster = useToaster();
  const handleAddList = () => {
    if (newEmail.trim() !== '') {
      if (!validateEmail(newEmail.trim())) {
        toaster.push(
          <Message showIcon type="error">
            Please enter a valid email address!
          </Message>,
          { placement: 'topEnd' }
        );
      } else if (emailList.some(item => item.emailid == newEmail.trim())) {
        toaster.push(
          <Message showIcon type="error">
            Email already exists in the list!
          </Message>,
          { placement: 'topEnd' }
        );
      } else {
        setEmailList(prevList => [
          ...prevList,
          { emailid: newEmail.trim(), typecode: typeCode, emailsts: true }
        ]);
        setNewEmail('');
      }
    }
  };

  return (
    <Drawer open={open} onClose={close} size="xs">
      <Drawer.Header>
        <Drawer.Title>
          <h5>Restrict Access</h5>
        </Drawer.Title>
      </Drawer.Header>
      <Drawer.Body>
        <Drawer.Actions style={Daction}>
          <div>
            <RadioGroup name="radioList" inline value={value} onChange={setValue}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: '10px',
                  flexDirection: 'column'
                }}
              >
                <div style={divStyle}>
                  <Radio value="Allow">
                    <h6>Allow Specific email id's</h6>
                    Allow specified emails to access your catalogue while blocking everyone else.
                  </Radio>
                </div>
              </div>
            </RadioGroup>
          </div>

          <div style={{ marginTop: '20px' }}>
            <label htmlFor="">Email Id</label>
            <InputGroup inside style={styles}>
              <Input
                type="email"
                value={newEmail}
                onChange={value => setNewEmail(value)}
                style={{ width: '100% !important' }}
              />
              <InputGroup.Button onClick={handleAddList}>Allow</InputGroup.Button>
            </InputGroup>
          </div>
          {emailList.length
            ? emailList.map(item => {
                return (
                  <InputGroup inside style={styles} key={item.emailid}>
                    <Input disabled value={item.emailid} />
                  </InputGroup>
                );
              })
            : null}
        </Drawer.Actions>
      </Drawer.Body>
    </Drawer>
  );
}
